export const CREDIT_AGE = 'Credit Age';
export const CREDIT_INQUIRIES = 'Credit Inquiries';
export const CREDIT_DEPTH_AGE = 'CREDIT DEPTH: AGE';
